import { createSelector } from '@reduxjs/toolkit';
import { selectFlatOldSaleTypeValue } from './selectFlatOldSaleTypeValue';
import { selectSaleTypeOptions } from './selectSaleTypeOptions';

export const selectFlatOldSaleTypeFilter = createSelector(
  [selectFlatOldSaleTypeValue, selectSaleTypeOptions],
  (value, options) => ({
    label: 'На вторичке',
    value,
    options,
  }),
);
